<template>
  <page-content></page-content>
</template>

<script>
  /*settings component from view directory by router*/

  // components
  import PageContent from './components/PageContent.vue';

  export default {
    name: 'FeedSettings',
    components: {
      PageContent,
    },
  };
</script>
